<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-2 shape-red shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2 class="display-2 text-white">Our FlexYard Projects
                                    <span>CP St. Paul Hump Yard. – St. Paul Yard features 36 classification tracks and nine departure tracks in addition to the receiving tracks.</span>
                                </h2>
                                <!-- <p class="lead  text-white">3Z Automation has fully designed and implemented hump yard control systems. It has been running for more than 7 years and proves to be robust and stable systems.</p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

        <section class="section section-lg bg-secondary section-skew">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-12">
                        <h1>
                            <i class="fa fa-road display-1"></i> &
                            <i class="fa fa-tasks display-1"></i>
                        </h1>
                        <h2 class="display-2">CP St. Paul Hump Yard </h2>
                        <p class="lead  text-muted">3Z Automation has fully designed and implemented hump yard control systems. It has been running for more than 7 years and proves to be robust and stable systems.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-lg-6 mb-5 mb-lg-10">
                        <div class="px-4">
                            <img v-lazy="'img/3z/fy1.png'"
                                 class="rounded img-center img-fluid shadow shadow-lg--hover">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">QT - CAR LIST</span>
                                    <!-- <small class="h6 text-muted">Car Detail</small> -->
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 mb-5 mb-lg-10">
                        <div class="px-4">
                            <img v-lazy="'img/3z/fy2.png'"
                                 class="rounded img-center img-fluid shadow shadow-lg--hover">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">QT - GUI</span>
                                    <!-- <small class="h6 text-muted">Car Detail</small> -->
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/3z/fy3.png'"
                                 class="rounded img-center img-fluid shadow shadow-lg--hover">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">WEB - DRAW TOOL</span>
                                    <!-- <small class="h6 text-muted">Car Detail</small> -->
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/3z/fy4.png'"
                                 class="rounded img-center img-fluid shadow shadow-lg--hover">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">WEB - GUI</span>
                                    <!-- <small class="h6 text-muted">Car Detail</small> -->
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
  name: "projectFlexyard",
  components: {}
};
</script>

<style lang="scss" scoped>
ul.list {
    padding-left: 1.2rem!important;
}
.section-skew {
    overflow: hidden;
    // padding-top: 20px;
    margin-top: 0px;
    position: relative;
    background: transparent;
    pointer-events: none;
    overflow: visible;
    &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: -120px;
        height: 200px;
        background: #f4f5f7;
        -webkit-transform: skew(0, -8deg);
        transform: skew(0, -8deg);
    }
}
</style>
